const tireBrands = {
    "athos": "Athos",
    "barum": "Barum",
    "bridgestone": "Bridgestone",
    "continental": "Continental",
    "doublecoin": "Double Coin",
    "dunlop": "Dunlop",
    "easyrider": "Easy Rider",
    "fulda": "Fulda",
    "goodyear": "Goodyear",
    "gtradial": "GT Radial",
    "hankook": "Hankook",
    "kumho": "Kumho",
    "longmarch": "Longmarch",
    "marshal": "Marshal",
    "matador": "Matador",
    "michelin": "Michelin",
    "nokian": "Nokian",
    "pirelli": "Pirelli",
    "pneulaurent": "Pneu Laurent",
    "sava": "Sava",
    "semperit": "Semperit",
    "westlake": "Westlake",
    "other": "Other",
}

export const TireBrands = { ...tireBrands };

export const TireBrand = function (brand) {
    return tireBrands[brand] ? tireBrands[brand] : brand
}
